import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  PHONE_VALIDATE,
  EMAIL_VALIDATE,
  ADDRESS_VALIDATE,
  USER_EXIST,
  NAME_VALIDATE
} from "../../../validation";
import { Form, Spinner, Button, InputGroup, Row, Col } from "react-bootstrap";
import { isUserExist } from "../../../actions/signup.action";
import {
  getRolesByIdAction,
  getUsersListAction,
  updateUserAction,
  makeUserActiveAction,
  getGroupRolesForUser,
  getGroupsForUserAction
} from "../../../actions/userManagement.action";
import { debounce, get } from "lodash";
import { bindActionCreators } from "redux";
import { isValidArray, getLocalstorage } from "../../../helper";
import { modifyDataForCreateUser } from "../helper";
import { ERROR_MSG, STATUS } from "../../../constant";
import { LoaderPage } from "../../../component/Loader";
import { toast } from "react-toastify";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import { AutoSuggestSelect } from "../../../component/AutoSuggestSelect";
import { ModalComponent, ModalTemplate } from "../../reusableComponent";
import PermissionHOC from "../../PermissionHOC";
import TermsCondition from "../../footer/TermsConditions";
import PrivacyPolicy from "../../footer/PrivacyPolicy";
import DisplayByPermission from "../../../component/DisplayByPermission";
import GroupManagementSidebar from "../../GroupManagement/GroupManagementSidebar";
import { successToastStyle, errorToastStyle } from "../../../customToast";
import { truncateData } from "../../../helper";

let isMobileNumberChanged = false;
export class CreateUserEditForm extends Component {
  constructor(props) {
    super(props);
    // this.modalRef = React.createRef();
    this.state = {
      userId: "",
      telCode: "",
      mobileNumber: "",
      email: "",
      name: "",
      designation: "",
      errors: {},
      type: "password",
      groupId: "",
      groupRoles: [],
      makeUserActiveInfo: null,
      submitBtnText: "UPDATE",
      dataChangeStatus: false,
      verified: false,
      isApiLoading: STATUS.LOADING,
      disableEditRole: false,
      showOrganization: false,
      isToggleOn: true,
      isProfiled: false,
      isIIGGroup: null,
      isIIGUserCount: false,
      iigAccess: false,
      dataUnsaved: false,
      allowPrompt: true
    };
  }

  componentDidMount = async () => {
    const {
      groups,
      groupData,
      getGroupRolesForUser,
      getGroupsForUserAction
    } = this.props;
    document.addEventListener("mousedown", this.handleClickOutside);
    !isValidArray(groups) && getGroupsForUserAction(undefined);
    const response = await getGroupRolesForUser(
      undefined,
      get(groupData, "groupId")
    );
    if (response) {
      const { data, status, message } = response;
      if (data.data !== null) {
        data.data.forEach(roles => {
          if (
            (get(groupData, "groupRoles", []) || []).indexOf(roles.roleId) !==
            -1
          ) {
            roles.checked = true;
          }
        });
      }
      this.getFilteredData({ sortData: data.data });
      this.setState({
        isApiLoading: STATUS.SUCCESS,
        rolesList: data.data,
        userId: get(groupData, "userID", ""),
        name: get(groupData, "name", ""),
        designation: get(groupData, "designation", ""),
        email: get(groupData, "email", ""),
        mobileNumber: get(groupData, "mobileNumber", ""),
        verified: get(groupData, "verified", false),
        defaultSelected: get(groupData, "groupId", ""),
        groupRoles: get(groupData, "groupRoles", ""),
        active: get(groupData, "active", false),
        groupId: get(groupData, "groupId", false),
        organisation: get(groupData, "organization", false),
        alternateMobileNumber: get(groupData, "alternateMobileNumber", false),
        id: get(groupData, "id", ""),
        disableEditRole: get(groupData, "disableEditRole", false),
        showOrganization: get(groupData, "groupId", false) === 54,
        isProfiled: get(groupData, "profiled", false),
        isIIGGroup: get(groupData, "iiggroup"),
        hasIIGaccess: get(groupData, "iigaccess"),
        iigAccess: get(groupData, "iigaccess"),
        iigStatus: get(groupData, "iigStatus"),
        errors: {
          userIdValidExist: { error: false },
          nameValid: { error: false },
          designation: { error: false },
          emailValid: { error: false },
          phoneValid: { error: false },
          phoneValidExist: { error: false },
          emailValidExist: { error: false },
          roles: { error: false },
          groupId: { error: false }
        }
      });
    }
  };

  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = event => {
    const { togglePopUp } = this.props;
    const { dataUnsaved, allowPrompt } = this.state;

    // Check if the click was outside the modal
    const modalRef = this.props.userModalRef && this.props.userModalRef.current;
    const isOutsideModal = modalRef && !modalRef.contains(event.target);

    // Check if the click was on the vertical scrollbar
    const isClickOnScrollbar =
      event.clientX > window.innerWidth - 7 &&
      (event.clientY >= 0 && event.clientY <= window.innerHeight);

    // If the click is outside the modal and not on the scrollbar
    if (isOutsideModal && !isClickOnScrollbar) {
      console.log(
        "Clicked outside the modal, but modal will not close.",
        dataUnsaved
      );
      console.log("allowPrompt", allowPrompt);
      if (dataUnsaved && allowPrompt && event.button === 0) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          "You have unsaved changes, are you sure you want to leave?"
        );

        if (confirmLeave) {
          togglePopUp();
          return;
        }
      }
    }
  };

  handleChange = event => {
    let { errors } = this.state;
    const { name, value } = event.target;
    const data = {
      [name]: value
    };
    if (name === "mobileNumber") {
      isMobileNumberChanged = true;
    }
    if (name === "groupId") {
      data["groupRoles"] = [];
      data["rolesList"] = [];
    }
    this.setState(prevState => ({
      ...data,
      dataChangeStatus: true,
      isEmailModified: name === "email" ? prevState.email !== value : false,
      dataUnsaved: true
    }));
  };

  handleUserNameChange = event => {
    let { errors } = this.state;
    let pasted = this.state.pasted;
    let userName = this.state.name;
    let nameInputValue = event.target.value;
    if (pasted) {
      errors.nameValid = NAME_VALIDATE(nameInputValue);
      userName = truncateData(nameInputValue);
      this.setState({
        name: userName
      });
    } else {
      let currentNameValue = this.state.name;
      errors.nameValid = NAME_VALIDATE(nameInputValue);
      if (currentNameValue.length < 30 || nameInputValue.length < 31) {
        this.setState({
          name: nameInputValue
        });
      }
    }

    this.setState({
      pasted: false,
      dataUnsaved: true
    });
  };

  handleUserNamePaste = event => {
    this.setState({
      pasted: true,
      dataUnsaved: true
    });
  };

  handleIsUserExist = async event => {
    const { userId, errors } = this.state;
    const errorRef = { ...errors };
    const response = await isUserExist(undefined, { userId });
    if (response && response.data && !response.data.status) {
      errorRef.userIdValid = USER_EXIST(true, userId, "user");
      errorRef.userIdValidExist = errorRef.userIdValid;
      this.setState({
        errors: errorRef
      });
    } else {
      errorRef.userIdValid = USER_EXIST(false, userId, "user");
      errorRef.userIdValidExist = errorRef.userIdValid;
      this.setState({
        errors: errorRef
      });
    }
  };

  handleIsMobileNoExist = async event => {
    const { mobileNumber, errors } = this.state;
    const errorRef = { ...errors };
    if (isMobileNumberChanged) {
      const response = await isUserExist(undefined, { mobileNumber });
      if (response && response.data && !response.data.status) {
        errorRef.phoneValid = USER_EXIST(true, mobileNumber, "Mobile Number");
        errorRef.phoneValidExist = errorRef.phoneValid;
        this.setState({
          errors: errorRef
        });
        isMobileNumberChanged = false;
      } else {
        errors.phoneValid = USER_EXIST(false, mobileNumber, "Mobile Number");
        errorRef.phoneValidExist = errorRef.phoneValid;
        isMobileNumberChanged = false;
        this.setState({
          errors: errorRef
        });
      }
    }
    return null;
  };

  onIIGAccess = () => {
    this.setState(prevState => ({
      iigAccess: !prevState.iigAccess,
      dataUnsaved: true
    }));
  };

  handleIsEmailExist = async event => {
    const { email, errors } = this.state;
    const errorRef = { ...errors };
    const response = await isUserExist(undefined, { email });
    if (response && response.data && !response.data.status) {
      errorRef.emailValid = USER_EXIST(true, email, "Email");
      errorRef.emailValidExist = errorRef.emailValid;
      this.setState({
        errors: errorRef
      });
    } else {
      errorRef.emailValid = USER_EXIST(false, email, "Email");
      errorRef.emailValidExist = errorRef.emailValid;
      this.setState({
        errors: errorRef
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    const oldProps = this.props;
    if (
      !nextProps.mobileNumber !== "" &&
      oldProps.mobileNumber !== nextProps.mobileNumber
    ) {
      this.setState({ mobileNumber: nextProps.mobileNumber });
    }
    if (!nextProps.email !== "" && oldProps.email !== nextProps.email) {
      this.setState({ email: nextProps.email });
    }
  }

  validateField = async (fieldName, value) => {
    let {
      errors,
      mobileNumber,
      email,
      name,
      designation,
      dataChangeStatus,
      isEmailModified,
      rolesList,
      defaultSelected,
      organisation,
      showOrganization
    } = this.state;
    switch (fieldName) {
      case "mobileNumber":
        errors.phoneValid = PHONE_VALIDATE(value);
        if (errors.phoneValid.error === false) {
          this.handleIsMobileNoExist();
        }
        break;
      case "alternateMobileNumber":
        if (value) {
          errors.alternateMobileNumber = PHONE_VALIDATE(value);
        } else {
          delete errors.alternateMobileNumber;
        }
        break;
      case "email":
        errors.emailValid = EMAIL_VALIDATE(value);
        if (errors.emailValid.error === false && isEmailModified) {
          this.handleIsEmailExist();
        }
        break;
      case "name":
        errors.nameValid = {
          error: !value,
          message: !value && ERROR_MSG.DEFAULT_MSG
        };
        break;
      case "address":
        errors.addressValid = ADDRESS_VALIDATE(value);
        break;
      case "designation":
        errors.designation = {
          error: !value,
          message: !value && ERROR_MSG.DEFAULT_MSG
        };
        break;
      default:
        errors.phoneValid = PHONE_VALIDATE(mobileNumber);
        errors.emailValid = EMAIL_VALIDATE(email);
        errors.nameValid = {
          error: !name,
          message: !name && ERROR_MSG.DEFAULT_MSG
        };
        errors.designation = {
          error: !designation,
          message: !designation && ERROR_MSG.DEFAULT_MSG
        };
        errors.roles = {
          error: !rolesList.filter(value => value.checked).length,
          message: "Field is required"
        };
        errors.orgValid = {
          error: showOrganization && !organisation,
          message: showOrganization && !organisation && "Field is required"
        };
        errors.groupId = {
          error: !defaultSelected,
          message: ERROR_MSG.DEFAULT_MSG
        };
        if (dataChangeStatus) {
          if (errors.phoneValid.error === false) {
            this.handleIsMobileNoExist();
          }
          if (isEmailModified) {
            this.handleIsEmailExist();
          }
          this.setState({
            dataChangeStatus: false
          });
        }
        break;
    }
    this.setState({
      errors: { ...errors }
    });
  };

  validateForm = () => {
    let { errors, showOrganization } = this.state;
    let {
      phoneValid,
      emailValid,
      nameValid,
      phoneValidExist,
      emailValidExist,
      userIdValidExist,
      groupId,
      roles,
      orgValid,
      alternateMobileNumber: alternateMobileNumberError
    } = errors;

    if (alternateMobileNumberError && alternateMobileNumberError.error) {
      return true;
    }

    if (showOrganization) {
      if (orgValid && orgValid.error) {
        return true;
      }
    }

    if (
      !phoneValid ||
      get(phoneValid, "error") ||
      (!emailValid || get(emailValid, "error")) ||
      (!phoneValidExist || get(phoneValidExist, "error")) ||
      (!emailValidExist || get(emailValidExist, "error")) ||
      (!userIdValidExist || get(userIdValidExist, "error")) ||
      (!nameValid || get(nameValid, "error")) ||
      (!groupId || get(groupId, "error")) ||
      (!roles || get(roles, "error"))
    ) {
      return true;
    }
    return false;
  };

  handleOtpModal = event => {
    event.preventDefault();
    this.validateField();
    let isValidData = this.validateForm();
    if (!isValidData) {
      this.openConfirmationAlert();
    } else {
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
    }
  };

  onChange = (value, key) => {
    const { getGroupRolesForUser } = this.props;
    if (key === "groupId") {
      this.setState(
        {
          rolesList: [],
          dataUnsaved: true
        },
        async () => {
          const response = await getGroupRolesForUser(undefined, value);
          if (response) {
            const { data, status, message } = response;
            status
              ? toast.success(
                  <p className="toast-text-alignment">{message}</p>,
                  successToastStyle
                )
              : toast.error(
                  <p className="toast-text-alignment">{message}</p>,
                  errorToastStyle
                );
            if (isValidArray(data.data)) {
              this.setState({
                rolesList: data.data
              });
              this.getFilteredData({ sortData: data.data });
            } else {
              this.setState({
                rolesList: []
              });
            }
          }
        }
      );
    } else {
      this.setState(async prevState => {
        prevState[key] = prevState[key] || [];
        const indexId = prevState[key].indexOf(+value);
        indexId !== -1
          ? prevState[key].splice(indexId, 1)
          : prevState[key].push(+value);
        prevState[key] = [...prevState[key]];
        return {
          [key]: prevState[key],
          dataUnsaved: true
        };
      });
    }
  };

  onError = (value, key) => {
    this.setState(prevState => {
      const error = isValidArray(prevState[key])
        ? { error: !prevState[key].length, message: ERROR_MSG.DEFAULT_MSG }
        : value;
      return {
        errors: {
          ...prevState.errors,
          [key]: error
        }
      };
    });
  };

  openConfirmationAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
      allowPrompt: !prevState.allowPrompt
    }));
  };

  onSubmit = async () => {
    const { updateUserDispatch, togglePopUp, callApiOnSuccess } = this.props;
    const { userId, id, showOrganization, iigAccess } = this.state;
    const params = { ...this.state, userID: userId };
    if (!params.alternateMobileNumber) delete params.alternateMobileNumber;
    if (!showOrganization) delete params.organisation;
    this.setState({ isApiLoading: STATUS.LOADING });
    togglePopUp();
    const registerResponse = await updateUserDispatch(undefined, {
      ...modifyDataForCreateUser(params),
      id
    });

    callApiOnSuccess();
    if (registerResponse) {
      const { status, message, error } = get(registerResponse, "data", {});
      status
        ? toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          )
        : (isValidArray(error) &&
            error.forEach(msg => {
              toast.error(
                <p className="toast-text-alignment">{msg}</p>,
                errorToastStyle
              );
            })) ||
          toast.error(
            <p className="toast-text-alignment">{message}</p>,
            errorToastStyle
          );
      this.setState({ isApiLoading: STATUS.SUCCESS, dataUnsaved: false });
      this.openConfirmationAlert();
    }
  };

  getFilteredData = sortedListingArr => {
    this.setState({
      sortedListingArr: get(sortedListingArr, "sortData", []),
      isSearching: get(sortedListingArr, "isSearching"),
      searchRoles: get(sortedListingArr, "value")
    });
  };

  onSelectRoles = value => {
    this.setState(prevState => {
      value.checked = !value.checked;
      const selectedRoles = prevState.rolesList.filter(value => {
        return value.checked;
      });
      return {
        rolesList: prevState.rolesList,
        error: {
          ...prevState.error,
          roles: {
            error: !selectedRoles.length,
            message: ERROR_MSG.DEFAULT_MSG
          }
        },
        dataUnsaved: true
      };
    });
  };

  onAutoSuggestChange = value => {
    const { groups } = this.props;
    this.setState({
      autoSuggestApiLoading: STATUS.LOADING,
      defaultSelected: value.searchedText,
      groupsList: []
    });
    get(this.autoSuggestApi, "cancel") && this.autoSuggestApi.cancel();
    this.autoSuggestApi = debounce(() => {
      let searchedText = get(groups, "data", []);
      if (value.searchedText) {
        const regEx = RegExp(value.searchedText, "i");
        searchedText = get(groups, "data", []).filter(value => {
          return regEx.test(value.name);
        });
      }
      this.setState({
        groupsList: searchedText
      });
    }, 1000);
    this.autoSuggestApi();
  };

  onOptionClick = value => {
    this.onChange(value.id, "groupId");
    this.setState(prevState => ({
      defaultSelected: value.name,
      groupId: value.id,
      errors: {
        ...prevState.errors,
        groupId: {
          error: !value,
          message: !value && ERROR_MSG.DEFAULT_MSG
        }
      }
    }));
    if (value.id === 54 || value.description === "Project Proponent Group") {
      this.setState({
        showOrganization: true
      });
    } else {
      this.setState({
        showOrganization: false
      });
    }
  };

  onMakeUserActive = () => {
    const {
      props: { makeUserActiveDispatch },
      state: { id, active, allowPrompt }
    } = this;
    // if user is not active then do this
    if (!active) {
      this.setState(prevState => ({
        active: !prevState.active,
        dataUnsaved: true
      }));
    } else {
      // if user is active then call the api first
      this.setState(
        {
          makeUserActiveInfo: null,
          isMakeUserApiLoading: true,
          isToggleOn: true,
          dataUnsaved: true
        },
        async () => {
          const response = await makeUserActiveDispatch(undefined, id);
          const { data = {} } = response.data || {};
          this.setState(prevState => ({
            isMakeUserApiLoading: false,
            active: data.changeActiveStatus ? !prevState.active : true, // active will be true if changeActiveStatus is true
            makeUserActiveInfo: !data.changeActiveStatus
              ? {
                  ...data
                }
              : null,
            allowPrompt: data.changeActiveStatus ? true : false
          }));
        }
      );
    }
  };

  onCloseModal = () => {
    console.log("within onCloseModel");
    this.setState(prevState => ({
      makeUserActiveInfo: null,
      allowPrompt: !prevState.allowPrompt
    }));
  };

  closeReadBannerModal = () => {
    this.setState({ isBannerModalVisible: false });
  };

  showReadBannerModal = key => {
    this.setState({ isBannerModalVisible: true, bannerContent: key });
  };
  proponentBlur = value => {};
  render() {
    const { onMakeUserActive, onCloseModal } = this;
    console.log("allowPromt", this.state.allowPrompt);

    const { groups, permission } = this.props;
    let {
      submitBtnText,
      userId,
      mobileNumber,
      email,
      name,
      designation,
      errors,
      active,
      groupRoles: stateGroupRoles,
      groupId: stateGroupId,
      isApiLoading,
      showAlert,
      sortedListingArr,
      defaultSelected,
      groupsList,
      isMakeUserApiLoading,
      makeUserActiveInfo,
      bannerContent,
      isBannerModalVisible,
      alternateMobileNumber,
      disableEditRole,
      isIIGGroup,
      showOrganization,
      organisation,
      hasIIGaccess,
      iigStatus,
      iigAccess
    } = this.state;
    const user = getLocalstorage("user");

    const iigStatusMap = {
      "(Pending on CRIP)": "text-warning",
      "(Rejected on CRIP)": "text-danger",
      "(Deactivated on CRIP)": "text-danger",
      "(Created on CRIP)": "text-success"
    };

    const iigStatusClass = iigStatusMap[iigStatus] || "";

    const validGroupCategories = ["PMG", "CENTRAL", "CENTRAL_DEPARTMENT"];

    const showIIGAccess = validGroupCategories.includes(
      get(user, "groupCategory")
    );

    const { groupId } = errors;
    if (+defaultSelected && isValidArray(get(groups, "data"))) {
      const selectedGroupId = get(groups, "data", []).filter(value => {
        return value.id === +defaultSelected;
      });
      defaultSelected = isValidArray(selectedGroupId)
        ? selectedGroupId[0].name
        : defaultSelected;
    }

    let isPermission = false;

    const userPermission = (sortedListingArr || []).find(
      value => get(value, "permission") === true
    );
    if (userPermission) {
      isPermission = true;
    }

    return (
      <div
        className="register-inner create-user-register-inner alignment-user-form"
        //ref={this.modalRef}
      >
        <LoaderPage loading={isApiLoading === STATUS.LOADING} />
        {makeUserActiveInfo && !makeUserActiveInfo.changeActiveStatus ? (
          <ModalComponent
            centered={true}
            onClose={onCloseModal}
            classes="user-management-active-info-modal"
            template={
              <ModalTemplate
                headerDisplay={true}
                headerTitle=""
                onSubmit={false}
                footerDisplay={false}
                bodyTemplate={
                  <>
                    <h3>
                      Please close the assigned project(s)/issue(s) of the user
                      before making the user inactive
                    </h3>
                    <ul>
                      {isValidArray(makeUserActiveInfo.projectIds) ? (
                        <li>
                          <h3>Project(s) Id</h3>
                          <span>
                            {makeUserActiveInfo.projectIds.join(", ")}
                          </span>
                        </li>
                      ) : null}
                      {isValidArray(makeUserActiveInfo.issueIds) ? (
                        <li>
                          <h3>Issue(s) Id</h3>
                          <span>{makeUserActiveInfo.issueIds.join(", ")}</span>
                        </li>
                      ) : null}
                      {isValidArray(makeUserActiveInfo.meetingIds) ? (
                        <li>
                          <h3>Meeting(s) Id</h3>
                          <span>
                            {makeUserActiveInfo.meetingIds.join(", ")}
                          </span>
                        </li>
                      ) : null}
                    </ul>

                    <Button onClick={onCloseModal}>Close</Button>
                  </>
                }
              />
            }
          />
        ) : null}

        <ConfirmationComponent
          show={showAlert}
          isLoading={isApiLoading}
          modalClass={"confirmation-modal"}
          saveHandler={this.onSubmit}
          closeHandler={this.openConfirmationAlert}
          content={"Are you sure you want to do this?"}
        />
        <Form className="signup-form">
          <Form.Group controlId="userId">
            <div className="d-flex checkBox justify-content-between position-relative">
              <Form.Label className="label-style">
                User ID <span className="required">*</span>
              </Form.Label>

              {this.state.isProfiled === true && (
                <div className="d-flex mt-2 mr-n2">
                  <p
                    className={`mb-0 mr-n3 pr-1 ${
                      this.state.isToggleOn && active
                        ? "toggle-active"
                        : " toggle-inactive"
                    }`}
                  >
                    {this.state.isToggleOn && active ? "Active" : "Inactive"}
                  </p>
                  {get(permission, "makeUserActiveInactive") ? (
                    <Form.Group
                      controlId="designation"
                      onChange={onMakeUserActive}
                      className="mb-0 ml-3 mr-1"
                    >
                      <Form.Check
                        type="checkbox"
                        label={
                          <span>
                            {isMakeUserApiLoading ? (
                              <Spinner animation="border" size="sm" />
                            ) : null}
                          </span>
                        }
                        checked={active}
                        className={`form-toggle ${
                          active ? "checked" : ""
                        } active-user`}
                      />
                    </Form.Group>
                  ) : null}
                </div>
              )}
            </div>
            <Form.Control
              name="userId"
              type="text"
              disabled
              value={userId}
              className="field-width"
            />
          </Form.Group>

          <Form.Group controlId="name">
            <Form.Label className="label-style">
              Name<span className="required">*</span>
            </Form.Label>
            <Form.Control
              name="name"
              type="text"
              value={name}
              onChange={this.handleUserNameChange}
              onPaste={this.handleUserNamePaste}
              onBlur={() => this.validateField("name", name)}
              isInvalid={errors.nameValid && errors.nameValid.error}
              disabled={!get(permission, "updateUserName")}
              placeholder="Enter Name"
              className="field-width"
            />
            <Form.Control.Feedback type="invalid">
              {errors.nameValid && errors.nameValid.error
                ? errors.nameValid.message
                : null}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="designation">
            <Form.Label className="label-style">
              Designation <span className="required">*</span>
            </Form.Label>
            <Form.Control
              name="designation"
              type="text"
              value={designation}
              onChange={this.handleChange}
              disabled={get(permission, "canViewOnlyProject")}
              onBlur={() => this.validateField("designation", designation)}
              isInvalid={errors.designation && errors.designation.error}
              placeholder="Enter Designation"
              className="field-width"
            />
            <Form.Control.Feedback type="invalid">
              {errors.designation && errors.designation.error
                ? errors.designation.message
                : null}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="email">
            <Form.Label className="label-style">
              Email <span className="required">*</span>
            </Form.Label>
            <Form.Control
              name="email"
              type="email"
              value={email}
              onChange={this.handleChange}
              disabled={get(permission, "canViewOnlyProject")}
              onBlur={() => this.validateField("email", email)}
              isInvalid={
                (errors.emailValid && errors.emailValid.error) ||
                (errors.emailValidExist && errors.emailValidExist.error)
              }
              placeholder="example@gmail.com"
              className="field-width"
            />
            <Form.Control.Feedback type="invalid">
              {errors.emailValid && errors.emailValid.error
                ? errors.emailValid.message
                : null}
              {errors.emailValidExist &&
              errors.emailValidExist.error &&
              !errors.emailValid.error
                ? errors.emailValidExist.message
                : null}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="mobileNumber">
            <Form.Label className="label-style">
              {" "}
              Mobile Number <span className="required">*</span>
            </Form.Label>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text
                  id="inputGroupPrepend"
                  className="mobile-number"
                >
                  +91
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                name="mobileNumber"
                type="text"
                maxLength="10"
                value={mobileNumber}
                onChange={this.handleChange}
                onBlur={() => this.validateField("mobileNumber", mobileNumber)}
                disabled={get(permission, "canViewOnlyProject")}
                isInvalid={
                  (errors.phoneValid && errors.phoneValid.error) ||
                  (errors.phoneValidExist && errors.phoneValidExist.error)
                }
                placeholder="Enter Mobile Number"
                className="mobile-field-width"
              />
              <Form.Control.Feedback type="invalid">
                {errors.phoneValid && errors.phoneValid.error
                  ? errors.phoneValid.message
                  : null}
                {errors.phoneValidExist &&
                errors.phoneValidExist.error &&
                !errors.phoneValid.error
                  ? errors.phoneValidExist.message
                  : null}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          <Form.Group controlId="mobileNumber">
            <Form.Label className="label-style">
              Alternate Mobile Number
            </Form.Label>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text
                  id="inputGroupPrepend"
                  className="mobile-number"
                >
                  +91
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                name="alternateMobileNumber"
                type="text"
                maxLength="10"
                value={alternateMobileNumber}
                onChange={this.handleChange}
                disabled={get(permission, "canViewOnlyProject")}
                onBlur={() => {
                  this.validateField(
                    "alternateMobileNumber",
                    alternateMobileNumber
                  );
                }}
                isInvalid={
                  errors.alternateMobileNumber &&
                  errors.alternateMobileNumber.error
                }
                placeholder="Enter Alternative Mobile Number"
                className="mobile-field-width"
              />
              <Form.Control.Feedback type="invalid">
                {errors.alternateMobileNumber &&
                errors.alternateMobileNumber.error
                  ? errors.alternateMobileNumber.message
                  : null}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          {isValidArray(
            isValidArray(groupsList) ? groupsList : get(groups, "data")
          ) ? (
            <Form.Group className="category">
              <Form.Label className="label-style">
                Select Group
                <span className="required">*</span>
              </Form.Label>
              <AutoSuggestSelect
                isLoading={false}
                defaultSelected={defaultSelected}
                isEditUserSearch={true}
                options={
                  isValidArray(groupsList) ? groupsList : get(groups, "data")
                }
                onChange={this.onAutoSuggestChange}
                disabled={
                  get(permission, "canViewOnlyProject") || disableEditRole
                }
                onOptionClick={this.onOptionClick}
                delay={10}
                redBorder={true}
                onBlur={this.proponentBlur}
              />
              {isIIGGroup !== null && (
                <div className="remaining-char pt-2">
                  Group from IIG : {isIIGGroup}
                </div>
              )}
              {get(errors, "groupId.error", null) ? (
                <span className="error-text">
                  {get(errors, "groupId.message", null)}
                </span>
              ) : null}
            </Form.Group>
          ) : null}

          {showOrganization ? (
            <Form.Group controlId="organisation">
              <Form.Label>Organization</Form.Label>
              <span className="required">*</span>
              <Form.Control
                name="organisation"
                type="text"
                value={organisation}
                onChange={this.handleChange}
                disabled={get(permission, "canViewOnlyProject")}
                onBlur={() => this.validateField("organisation", organisation)}
                isInvalid={errors.orgValid && errors.orgValid.error}
                placeholder="Enter Organization"
              />
              <Form.Control.Feedback type="invalid">
                {get(errors, "orgValid.message", null)}
              </Form.Control.Feedback>
            </Form.Group>
          ) : null}

          {showIIGAccess ? (
            hasIIGaccess ? (
              <Form.Check className="form-checkbox checked-disable pt-1">
                <Form.Check.Input
                  type="checkbox"
                  className="iig-access-checkbox"
                />
                <Form.Check.Label className="d-flex iig-access">
                  <div className="pt-1 iig-access-text">CRIP Access </div>
                  <div className={`ml-3 pt-1 ${iigStatusClass}`}>
                    {iigStatus}
                  </div>
                </Form.Check.Label>
              </Form.Check>
            ) : (
              <Form.Check
                className={`form-checkbox iig-checkbox ${
                  iigAccess ? "checked" : ""
                } pt-1`}
              >
                <Form.Check.Input type="checkbox" />
                <Form.Check.Label
                  className="d-flex iig-access"
                  onClick={this.onIIGAccess}
                >
                  <div className="pt-1">CRIP Access</div>
                </Form.Check.Label>
              </Form.Check>
            )
          ) : null}

          {isValidArray(sortedListingArr) && (
            <React.Fragment>
              <Form.Group as={Row} controlId="category" className="group-roles">
                <Form.Label className="select-group roles-select-group">
                  Roles
                  <span className="required">*</span>
                </Form.Label>
                <div className="select-role">
                  {(sortedListingArr || []).map((value, index) => {
                    if (get(value, "permission") !== true) {
                      return (
                        <div
                          value={get(value, "id")}
                          className="selected-group-role checkbox-style roles"
                        >
                          <Form.Label aria-label={get(value, "roleName")} />
                          <Form.Check
                            type="checkbox"
                            value={get(value, "roleId")}
                            id={get(value, "roleName")}
                            label={get(value, "roleName")}
                            onClick={e => {
                              this.onSelectRoles(value);
                            }}
                            className={`form-checkbox ${
                              value.checked ? "checked" : ""
                            } ${disableEditRole ? "disabled-checkbox" : null} ${
                              this.props.isEdit &&
                              this.props.permission.canViewOnlyProject
                                ? "checked checked-disable"
                                : ""
                            }`}
                            disabled={disableEditRole}
                          />
                        </div>
                      );
                    }
                  })}
                </div>
                {get(errors, "roles.error", null) ? (
                  <span className="error-text">
                    {get(errors, "roles.message", null)}
                  </span>
                ) : null}
              </Form.Group>
            </React.Fragment>
          )}

          {isValidArray(sortedListingArr) && isPermission && (
            <React.Fragment>
              <Form.Group
                as={Row}
                controlId="category"
                className="group-roles permission-group"
              >
                <Form.Label className="select-group  permission-select-group">
                  Permissions
                </Form.Label>
                <div className="select-role">
                  {(sortedListingArr || []).map((value, index) => {
                    if (get(value, "permission")) {
                      return (
                        <div
                          value={get(value, "id")}
                          className="selected-group-role checkbox-style roles"
                        >
                          <Form.Label aria-label={get(value, "roleName")} />
                          <Form.Check
                            type="checkbox"
                            value={get(value, "roleId")}
                            id={get(value, "roleName")}
                            label={get(value, "roleName")}
                            onClick={e => {
                              this.onSelectRoles(value);
                            }}
                            className={`form-checkbox ${
                              value.checked ? "checked" : ""
                            } ${disableEditRole ? "disabled-checkbox" : null} ${
                              this.props.isEdit &&
                              this.props.permission.canViewOnlyProject
                                ? "checked checked-disable"
                                : ""
                            }`}
                            disabled={disableEditRole}
                          />
                        </div>
                      );
                    }
                  })}
                </div>
                {get(errors, "roles.error", null) ? (
                  <span className="error-text">
                    {get(errors, "roles.message", null)}
                  </span>
                ) : null}
              </Form.Group>
            </React.Fragment>
          )}

          <DisplayByPermission display={!get(permission, "canViewOnlyProject")}>
            <Button
              variant="primary"
              type="submit"
              className="btn-orange full-width edit-create-user-btn"
              onClick={this.handleOtpModal}
            >
              {submitBtnText}
            </Button>
          </DisplayByPermission>
        </Form>

        {bannerContent === "termsConditions" ? (
          <TermsCondition
            show={isBannerModalVisible}
            closeModal={this.closeReadBannerModal}
          />
        ) : null}
        {bannerContent === "privacyPolicy" ? (
          <PrivacyPolicy
            show={isBannerModalVisible}
            closeModal={this.closeReadBannerModal}
          />
        ) : null}
      </div>
    );
  }
}

CreateUserEditForm.propTypes = {
  history: PropTypes.shape({})
};

CreateUserEditForm.defaultProps = {
  history: {}
};

function mapStateToProps(state) {
  return {
    groups: state.userManagementReducer.groups,
    rolesList: state.userManagementReducer.rolesList,
    isApiLoading: state.userManagementReducer.isApiLoading
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getRolesDispatch: getRolesByIdAction,
      updateUserDispatch: updateUserAction,
      getUsersListDispatch: getUsersListAction,
      makeUserActiveDispatch: makeUserActiveAction,
      getGroupRolesForUser,
      getGroupsForUserAction
    },
    dispatch
  );
}

export default PermissionHOC(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateUserEditForm)
);
